import type { AppFilter } from '../../../types';
import type { FilterFormValues } from '../../types';
import type { NumberFilterFormValue } from './types';
import { AppFilterOperator } from '../../../constants';

const DEFAULT_OPERATOR = AppFilterOperator.EQUAL;

export const getInitialFormValues = (
  currentFilter: AppFilter,
): FilterFormValues<NumberFilterFormValue> => ({
  operator: currentFilter.operator ?? DEFAULT_OPERATOR,
  values: (currentFilter.values ?? []).map((value) =>
    typeof value === 'string' ? Number(value) : value,
  ),
});

export const getFilterToSubmit = (
  currentFilter: AppFilter,
  formValues: FilterFormValues<NumberFilterFormValue>,
): AppFilter => ({
  ...currentFilter,
  operator: formValues.operator,
  /*
    formValues.values will be undefined when the form has no form items.
    This is possible when operator === APP_FILTER_OPERATORS.IS_NULL (cause the only form item is not rendering)
    Thus, to detect a situation when there are no values, but the filter is set, we set values as list with null element
   */
  values: formValues.values ?? [null],
});

export const getFilterToReset = (currentFilter: AppFilter): AppFilter => ({
  ...currentFilter,
  operator: DEFAULT_OPERATOR,
  values: [],
});
